import { selectIsPremium, useSession } from './session';
import { useUI } from './ui';

// Use in any click handler:  if (!requirePremium('why')) return;
// Free users get the pricing modal, Premium users get `true`.
export const requirePremium = (reason) => {
  if (selectIsPremium(useSession.getState())) return true;
  useUI.getState().openPricing(reason);
  return false;
};